import { StateEnum } from "../defines";
import { StateBase_Proxy } from "./StateBase_Proxy";

export class State_15 extends StateBase_Proxy {
  constructor() {
    super(StateEnum.Normal, void 0, void 0, void 0, void 0);
  }
}